import React from "react";
import { useIntl } from "react-intl";
import sharedMessages from "../../../../shared-messages";
import Password from "./password";

const CreatePasswordField = () => {
  const { formatMessage } = useIntl();

  return (
    <Password
      email={formValues => formValues.email}
      username={formValues => formValues.userName}
      id="create-password"
      name="password"
      label={formatMessage(sharedMessages.createPassword)}
      aria-required="true"
    />
  );
};

export default CreatePasswordField;
